import { H5 } from '@/components';
import React from 'react';
import * as styles from './index.module.less';
import { PublicClose } from 'notta-web-icon';
import { AI_NOTE_ID } from '@/modules/home-page/components/ai-note';

interface IProp {
  type: 'en' | 'ja';
  className?: string;
  onClose?: (e) => void;
}

const BANNER_CONTENT = {
  ja: {
    title: (
      <>
        📣 【Nottaアプリ6.6.0】
        <wbr />
        最新バージョン
        <wbr />が<wbr />
        リリース
        <wbr />
        されました
      </>
    ),
    desc: (
      <>
        アプリストア
        <wbr />で<wbr />
        「Notta」
        <wbr />を<wbr />
        検索し、
        <wbr />
        「アップデート」
        <wbr />を<wbr />
        クリックして、
        <wbr />
        リニューアル
        <wbr />
        された
        <wbr />
        <a href={`/#${AI_NOTE_ID}`}>「AI要約」</a>
        <wbr />
        機能
        <wbr />を<wbr />
        ぜひ
        <wbr />
        体験
        <wbr />
        してみて
        <wbr />
        ください
      </>
    ),
  },
  en: {
    title: '📣 [Notta app 6.6.0] The latest version has been released!',
    desc: 'Go to the app store and update your Notta app to enjoy the enhanced "AI Summary" feature.',
  },
};

const StopServingBanner = ({ type = 'ja', className = '', onClose }: IProp) => {
  const { title, desc } = BANNER_CONTENT[type];

  return (
    <div className={`${styles.banner_wrapper} ${className}`}>
      <div className={styles.content_wrapper}>
        <div className={styles.content_main}>
          <H5 as="p" className={styles.title} isWordKeepAll={type === 'ja'}>
            {title}
          </H5>
          <H5 as="p" className={styles.desc} isWordKeepAll={type === 'ja'}>
            {desc}
          </H5>
        </div>
      </div>
      <button className={styles.close_btn} onClick={onClose}>
        <PublicClose />
      </button>
    </div>
  );
};
export default StopServingBanner;
